module.exports = "img/flags/PT.3b96200.png";